import { FAILED, LOADING, SUCCESS, ACTION, RESET } from './constants';

export const initialState = {
//   customerSubmissionUnblock: {
  dataRequestFile: null,
  isLoadingRequestFile: false,
//   },
};

export default function reducer(state = initialState, action) {
  const { type, data, isLoading, message, key } = action;
  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case ACTION:
      return {
        ...state,
        action: data,
      };
    case RESET:
      return{
        ...state,
        [key]: null
      };
    default:
      return state;
  }
}
